import { render, staticRenderFns } from "./ResourceLinkView.vue?vue&type=template&id=a729bb32"
import script from "./ResourceLinkView.vue?vue&type=script&lang=js"
export * from "./ResourceLinkView.vue?vue&type=script&lang=js"
import style0 from "./ResourceLinkView.vue?vue&type=style&index=0&id=a729bb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports